import cn from 'classnames';
import styles from './pricingTable.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';
import isBoolean from 'lodash/isBoolean';

export const tableColumns = [
  {
    name: 'name',
    title: 'Features',
    className: styles.nameCol,
    stickyLeft: true,
    cellCallback: ({ cellData }) => (isBoolean(cellData) ? 'Included' : cellData),
  },
  {
    name: 'pricePerDeal',
    title: 'Price per deal',
    className: cn(styles.valueCol, alignStyles.alignRight),
    cellCallback: ({ cellData }) => (isBoolean(cellData) ? 'Included' : cellData),
  },
];

export const staticTableCollection = [
  {
    name: '30-day setup and staging period',
    pricePerDeal: true,
  },
  {
    name: 'Unlimited pages',
    pricePerDeal: true,
  },
  {
    name: 'Unlimited users',
    pricePerDeal: true,
  },
  {
    name: 'Unlimited admins',
    pricePerDeal: true,
  },
  {
    name: 'Unlimited fanatical 24x7x365 phone & email support',
    pricePerDeal: true,
  },
];
